module.exports = __webpack_public_path__ + "img/SIL认证.240e7c03.svg";